//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

//App
import { RestResponse } from 'src/app/_shared/models';
import { AppAnimations } from 'src/app/_shared/animations';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'event-detail',
  templateUrl: './event-detail.component.html',
  animations: [AppAnimations],
})

export class EventDetailComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  eventId: number;
  isMobile: boolean;
  isEventReady: boolean = false;
  formattedJson: string = '';
  event: any;
  private subs = new Unsubscriber();

  constructor(
    private _deviceService: DeviceDetectorService,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    public _meta: MetaService,
    private _route: ActivatedRoute,
    private settingsService: SettingsService,
  ) {
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));

    this.isMobile = this._deviceService.isMobile();
    this.subs.addSub = this._route.params.subscribe(params => {
      this.eventId = params['id'];
      this.getEventById(params['id']);
    })
  }

  ngOnInit() {

  }

  getEventById(_eventId: number) {
    this.subs.addSub = this.settingsService.getEventByEventId(_eventId)
      .subscribe(
        (res: RestResponse) => {
          this.event = res.data;
          // console.log('@@@event',this.event);
          // this.formattedJson = JSON.stringify(JSON.parse(this.event.jsonContent), null, 2);
          this.isEventReady = true;
        },
        (err: RestResponse) => {
          this.isEventReady = true;
          console.log(err);
        }
      );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
